import type { DetectedLink } from '../../integrations';

const ASANA_TASK_GID = /\d{10,}/;

function parseAsanaTaskGid(segment: string): string | null {
  const trimmed = segment.trim();
  if (!ASANA_TASK_GID.test(trimmed)) return null;
  return trimmed;
}

export function detectAsanaLink(url: string): DetectedLink | null {
  const v1ProjectMatch = url.match(
    /https?:\/\/app\.asana\.com\/1\/[^/]+\/project\/([^/?#]+)\/task\/([^/?#]+)/i
  );
  if (v1ProjectMatch) {
    const taskGid = parseAsanaTaskGid(v1ProjectMatch[2]);
    if (!taskGid) return null;
    return {
      url,
      integrationType: 'asana',
      resourceType: 'task',
      resourceId: taskGid,
      asanaProjectGid: v1ProjectMatch[1],
    };
  }

  const v1TaskMatch = url.match(/https?:\/\/app\.asana\.com\/1\/[^/]+(?:\/[^/]+)*\/task\/([^/?#]+)/i);
  if (v1TaskMatch) {
    const taskGid = parseAsanaTaskGid(v1TaskMatch[1]);
    if (!taskGid) return null;
    return {
      url,
      integrationType: 'asana',
      resourceType: 'task',
      resourceId: taskGid,
    };
  }

  const legacyMatch = url.match(/https?:\/\/app\.asana\.com\/0\/([^/?#]+)\/([^/?#]+)/i);
  if (legacyMatch) {
    const projectGid = legacyMatch[1];
    const taskGid = parseAsanaTaskGid(legacyMatch[2]);
    if (!taskGid) return null;
    if (projectGid === 'inbox' || projectGid === 'my_tasks') {
      return null;
    }
    return {
      url,
      integrationType: 'asana',
      resourceType: 'task',
      resourceId: taskGid,
      asanaProjectGid: projectGid === '0' ? undefined : projectGid,
    };
  }

  return null;
}
